import React from 'react';
import { NewShopProvider } from 'contexts/create-shop.context';
import CreateShopContent from './content';

const CreateShopLayout = () => {
  return (
    <NewShopProvider>
      <CreateShopContent />
    </NewShopProvider>
  );
};

export default CreateShopLayout;
